import { ToastContainer } from 'react-toastify';
import styled, { css } from 'styled-components';
import { desktopMediaQuery } from 'utils/mediaQuery';

export const Container = styled(ToastContainer)`
    ${desktopMediaQuery(css`
        right: 40px;
        top: 40px;
    `)}
`;
